import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetStudentAttendance = async function(parameters) {
    try {
        const { classgrade } = parameters
        const { date } = parameters

        if (classgrade === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: classgrade')
            )
        if (date === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: date')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/class-grade/${classgrade}/class-date/${date}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostAttendance = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/class-attendance`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
